import { Cadastro } from "../../components/cadastro/Cadastro";

export const CadastroPage = () => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Cadastro />    
        </div>
    )
}